exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-group .field[data-v-4c1e8204]{border-bottom:1px solid #e9e9e9}", ""]);

// exports
